<template>
<div class="bg_white">
  <div v-if="isShow" class="">
    <div v-if="isLoading">
      <div class="campaign_image"><img :src="setImage()" alt=""></div>
      <div class="mt24 pl20 pr20">
        <div class="">
          <div v-if="!apiResponse.available && apiResponse.expired" class="">
            <p class="expired_text ab">エントリー期間が過ぎております</p>
          </div>
          <div v-else-if="!apiResponse.available && !apiResponse.expired" class="">
            <p class="expired_text ab">エントリーできませんでした。<br>以下の理由が考えられます。<br><br>・すでにエントリー受付済み<br>・対象製品が毎月定期購入になっていない<br><br>ご不明点はコールセンターまでお問合せ下さい。</p>
          </div>
          <div v-else class="">
            <p class="campaign_title">【新規登録キャンペーン】</p>
            <div class="text_wrap">
              <p class="campaign_text">開催期間中に新規登録した方が対象商品を毎月定期購入にしていただくと、2か月目の製品お届け時に同じ製品をもう1つプレゼント！</p>
              <button @click="apply()" :class="[isDisable ? 'disable' : 'active']" :disabled="isDisable" class="entery_btn ab mt16" type="button" name="button">プレゼント申し込み</button>
              <p class="expired_text ab">{{ entryText }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</div>

</template>

<script>
import Config from '@/config/config';
import Check from '@/model/getToken'
import Campaign from '@/components/api/campaign/newRegistration'

export default {
  data() {
    return {
      isShow: true,
      isDisable: false,
      entryText: '',
      isLoading: false,
      apiResponse: {
        available: false,
        campaign: {
          campaignCode: '',
          campaignName: '',
        },
        expired: false,
        imagePath: ''
      }
    }
  },
  methods: {
    initialized() {
      this.isDisable = false;
      this.entryText = '';
      this.isLoading = false;
      this.apiResponse.available = false;
      this.apiResponse.campaign.campaignCode = '';
      this.apiResponse.campaign.campaignName = '';
      this.apiResponse.expired = false;
    },
    setData(data) {
      this.apiResponse.available = data.available;
      if(data.campaign != null) {
        this.apiResponse.campaign.campaignCode = data.campaign.campaignCode;
        this.apiResponse.campaign.campaignName = data.campaign.campaignName;
      }
      this.apiResponse.expired = data.expired;
      this.apiResponse.imagePath = data.imagePath;
    },
    setImage() {
      return Config.APIURL + this.apiResponse.imagePath;
    },
    async apply() {
      this.isDisable = true;
      console.log('キャンペーンコード');
      console.log(this.apiResponse.campaign.campaignCode);
      await Campaign.entryNewRegistration(this.apiResponse.campaign.campaignCode).then((val) => {
        console.log('申し込み');
        console.log(val);
        if(val.resultStatus == 'OK') {
          this.entryText = 'エントリー受付完了しました！';
        } else {
          this.isDisable = false;
          this.entryText = 'エントリーできませんでした。' + val.errorDescription;
        }
      });
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.initialized();
      await Campaign.getNewRegistration().then((val) => {
        console.log('新規登録キャンペーン情報');
        console.log(val);
        this.isLoading = true;
        this.setData(val);
      });
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.text_wrap {
  margin-top: 32px;
}
.entery_btn {
  border: none;
  border-radius: 10px;
  font-size: 18px;
  line-height: 1.3;
  padding: 15px 0;
  text-align: center;
  width: 100%;
}
.entery_btn span {
  font-size: 12px;
}
.entery_btn.active {
  background-color: #ffc000;
  color: #000;
}
.entery_btn.disable {
  background-color: #595959;
  color: #fff;
}

.expired_text {
  color: red;
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/views/campaign/NewRegistration.vue